import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledCountryTooltipContainer = styled.div`
    display: inline-block;
    width: fit-content;
    ${mixins.setFontVariant("primaryItem", colorsPalettes.carbon[400])};
`;

export const StyledCitiesTooltipContainer = styled.div`
    display: contents;
    ${mixins.setFontVariant("primaryItem", colorsPalettes.carbon[250])};
    white-space: normal;
`;

const StyledTooltipSecondaryText = styled.p`
    ${mixins.setFontVariant("sectionTitle", colorsPalettes.carbon[250])};
    white-space: normal;
`;

export const StyledIntentCountryIcon = styled.div`
    display: flex;
    margin-right: 8px;
`;

export const StyledEmptyTooltip = styled(StyledTooltipSecondaryText)`
    max-width: 170px;
    text-align: left;
`;

export const StyledIntentTooltipContentWrapper = styled(FlexRow)`
    align-items: flex-start;
    margin-bottom: 12px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledIntentTooltipRowCountry = styled.div`
    display: inline-block;
    white-space: normal;
`;
